webpackJsonp([11],{

/***/ 737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(780);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7d8514c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(826);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7d8514c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_fine_plays__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_company_organizations__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(108);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      MR_AUTHORITY_HEAD_OF_BRANCH: __WEBPACK_IMPORTED_MODULE_7__config__["e" /* MR_AUTHORITY_HEAD_OF_BRANCH */],
      MR_AUTHORITY_HEAD_OF_DEPARTMENT: __WEBPACK_IMPORTED_MODULE_7__config__["f" /* MR_AUTHORITY_HEAD_OF_DEPARTMENT */],
      MR_AUTHORITY_SM: __WEBPACK_IMPORTED_MODULE_7__config__["g" /* MR_AUTHORITY_SM */],
      companies: [],
      branches: [],
      company: __WEBPACK_IMPORTED_MODULE_7__config__["m" /* MS_COMPANY_CODE */],
      branch: null,
      finePlays: []
    };
  },

  computed: {
    canFetchBranches: function canFetchBranches() {
      var _this = this;

      var authorities = [__WEBPACK_IMPORTED_MODULE_7__config__["e" /* MR_AUTHORITY_HEAD_OF_BRANCH */], __WEBPACK_IMPORTED_MODULE_7__config__["f" /* MR_AUTHORITY_HEAD_OF_DEPARTMENT */], __WEBPACK_IMPORTED_MODULE_7__config__["g" /* MR_AUTHORITY_SM */]];
      return authorities.findIndex(function (n) {
        return n === _this.$auth.user().authority;
      }) === -1;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    setNavigatorLinks: 'navigator/setLinks',
    setNavigatorTitle: 'navigator/setTitle'
  }), {
    fetchBranches: function fetchBranches() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.branch = null;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api_company_organizations__["a" /* default */].getBranches({ company_code: _this2.company });

              case 3:
                res = _context.sent;

                _this2.branches = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(res.data.data, function (n) {
                  return n.branch_code !== '0';
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchFinePlays: function fetchFinePlays() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__api_fine_plays__["a" /* default */].get({ active: true, company_code: _this3.company, branch_code: _this3.branch });

              case 2:
                res = _context2.sent;

                _this3.finePlays = res.data.data;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    fetchData: function fetchData() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var loading;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loading = _this4.$loading.show();
                _context3.prev = 1;
                _context3.next = 4;
                return _this4.fetchFinePlays();

              case 4:
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](1);

                console.log(_context3.t0);

              case 9:
                loading.hide();

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[1, 6]]);
      }))();
    },
    handleChangeCompany: function handleChangeCompany() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.fetchBranches();

              case 2:
                _context4.next = 4;
                return _this5.fetchFinePlays();

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    handleClickFinePlay: function handleClickFinePlay(finePlayId) {
      this.$router.push({ name: 'finePlays.show', params: { finePlayId: finePlayId } });
    }
  }),
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.fetchData();

            case 2:
              _context5.next = 4;
              return _this6.fetchBranches();

            case 4:
              _this6.setNavigatorLinks([]);
              _this6.setNavigatorTitle('ファインプレー');

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this6);
    }))();
  }
});

/***/ }),

/***/ 825:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(69);


var resource = 'company-organizations';
var getBranches = function getBranches(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/branches', { params: params });
};
var getDistricts = function getDistricts(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/districts', { params: params });
};
var getTeams = function getTeams(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/teams', { params: params });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getBranches: getBranches,
  getDistricts: getDistricts,
  getTeams: getTeams
});

/***/ }),

/***/ 826:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fine_plays_page"},[_c('div',{staticClass:"search_group"},[_c('div',{staticClass:"search_item"},[_c('div',{staticClass:"search_item_label"},[_vm._v("組織")]),_vm._v(" "),_c('div',{staticClass:"search_item_select"},[_c('el-select',{attrs:{"clearable":"","placeholder":""},on:{"change":_vm.fetchFinePlays},model:{value:(_vm.branch),callback:function ($$v) {_vm.branch=$$v},expression:"branch"}},_vm._l((_vm.branches),function(item){return _c('el-option',{key:item.branch_code,attrs:{"label":item.branch_name,"value":item.branch_code}})}),1)],1)])]),_vm._v(" "),_c('div',{staticClass:"fine_plays_group"},_vm._l((_vm.finePlays),function(finePlay){return _c('div',[_c('div',{staticClass:"fine_play_item",on:{"click":function($event){return _vm.handleClickFinePlay(finePlay.id)}}},[_c('div',{staticClass:"fine_play_date_name"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("dateFormat")(finePlay.created_at)))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(finePlay.institution.abbreviated_name_kanji))])]),_vm._v(" "),_c('div',{staticClass:"fine_play_title"},[_c('span',[_vm._v(_vm._s(finePlay.presenter_company_code))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(finePlay.employee.name_kanji))])])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.9a94356c0b4934260007.js